var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "select_svg__a",
  width: 120,
  height: 120,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M119.777 59.972c0 33.03-26.776 59.806-59.806 59.806S.166 93.002.166 59.972 26.942.167 59.971.167c33.03 0 59.806 26.776 59.806 59.805Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#select_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 57.667,
  cy: 54.833,
  r: 30.167,
  fill: "#C0D8F0",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 59.065,
  cy: 55.034,
  fill: "#C0D8F0",
  rx: 17.051,
  ry: 15.602,
  transform: "rotate(32.265 59.065 55.034)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.667,
  d: "m71.166 71.5 1.833 3.833M35.499 47.833s-1.101 1.925-.992 6.667M38.166 42.104s8.556-13.486 25.234-9.798c14.902 3.297 17.266 19.361 17.266 19.361M36.833 64.667s3.047 8.08 15 12.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  stroke: "#36485C",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.667,
  d: "m108.721 103.71-17.974 9.704-3.766-6.18c-1.347-1.994-2.23-2.715-4.62-2.958l-2.554.221a6.64 6.64 0 0 1-3.127-1.148L56.345 89.238a3.696 3.696 0 0 1-.927-5.172 3.69 3.69 0 0 1 5.01-.993l14.185 8.556-17.372-31.85c-1.023-1.986.49-5.665 4.906-4.497 1.818.78 11.699 22.597 8.977 16.53-.555-1.239-2.165-4.192-2.165-4.192-.345-1.06-.895-3.211 2.165-4.676 3.061-1.464 4.842 1.803 5.901 3.061-.684-1.677-.085-5.041 2.07-5.843 2.149-.81 4.069.257 4.915 2.008l1.721 3.112s-.697-2.933 1.25-4.205c3.378-2.208 5.615 1.697 6.998 4.228l8.371 15.42a30.397 30.397 0 0 1 3.649 12.383l.272 3.767c.118.956.302 1.913.552 2.84l1.898 3.995Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "m93.942 117.573-6.645-3.655 23.966-13.394.984 5.43-18.305 11.619Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeWidth: 1.667,
  d: "m88.401 109.484 3.311 5.518M107.897 102.128l2.208 3.679M76.776 65.562l4.118 8.661M84.939 63.741l3.301 7.154M69.616 68.713l4.43 9.004"
}))));
export default SvgSelect;